<template>
  <v-autocomplete data-testid="month__autocomplete" ref="element"
    :items="monthList" outlined dense :label="label || 'Month'"
    :error-messages="error" v-model="content" @change="updateValue()" :hide-details="hidedetails" :disabled="disabled"
  ></v-autocomplete>
</template>

<script>
  export default {
    activated() {
      this.setValue();
      this.updateValue();
    },
    mounted() {
      let autocompleteInput = this.$refs.element.$el.querySelector('input');
      autocompleteInput.addEventListener('focus', this.onFocus, true);
    },
    created() {
      this.setValue();
      this.updateValue();
    },
    data: () => ({
      content: "",
      monthList: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    }),
    props: {
      error: {
        type: [String, Array],
      },
      label: {
        type: String,
      },
      value: {
        type: String
      },
      hidedetails: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
      // required: {
      //   type: Boolean,
      //   default: false
      // }
    },
    methods: {
      setValue: function(){
        this.content = this.value;
      },
      updateValue: function () {
        
        this.$emit('input', this.content);
        this.$emit('change', this.content);
      },
      setFocus: function(){
        this.$nextTick(() => {
          this.$refs.element.$el.querySelector('input').focus();
        });
      },
      onFocus () {
        this.$refs.element.isMenuActive = true  // open item list
      }
    },
    computed:{
    },
    watch: {
      value: function(){
        this.setValue();
      }
    }
  }
</script>